// Single source of truth — services/api.js REACT_APP_API_BASE_URL env var padhta hai
export { BASE_URL as API_BASE_URL } from '../services/api';

// Status color mapping
export const statusColors = {
  APPROVAL_PENDING: 'bg-orange-100 text-orange-700 border-orange-300',
  CONFIRMED: 'bg-emerald-100 text-emerald-700 border-emerald-300',
  UNCONFIRMED: 'bg-gray-100 text-gray-700 border-gray-300',
  CANCELLED: 'bg-red-100 text-red-700 border-red-300',
  RETURN: 'bg-pink-100 text-pink-700 border-pink-300',
  SHIPPING: 'bg-purple-100 text-purple-700 border-purple-300',
  OUT_FOR_DELIVERY: 'bg-cyan-100 text-cyan-700 border-cyan-300',
  DELIVERED: 'bg-green-100 text-green-700 border-green-300',
  PENDING: 'bg-yellow-100 text-yellow-700 border-yellow-300'
};

// Lead Status Options
export const leadStatusOptions = [
  'New Lead',
  'Not Connected',
  'Call back',
  'Call disconnected by customer',
  'Future Call back',
  'Not Interested',
  'Prank call',
  'Order Placed',
  'Switch Off'
];

// Get Lead Status Color
export const getLeadStatusColor = (status) => {
  const colors = {
    'New Lead': 'bg-blue-100 text-blue-700',
    'Not Connected': 'bg-gray-100 text-gray-700',
    'Call back': 'bg-yellow-100 text-yellow-700',
    'Call disconnected by customer': 'bg-orange-100 text-orange-700',
    'Future Call back': 'bg-purple-100 text-purple-700',
    'Not Interested': 'bg-red-100 text-red-700',
    'Prank call': 'bg-pink-100 text-pink-700',
    'Order Placed': 'bg-green-100 text-green-700',
    'Switch Off': 'bg-gray-400 text-white'
  };
  return colors[status] || 'bg-gray-100 text-gray-700';
};

// Mock Leads Data
export const mockLeads = [
  { id: '123912', date: '18/03/2024, 04:09 PM', name: 'Surendra Kannuajia', phone: 'XXXXXX2254', product: '', category: 'Ayurvedic Men Wellness', payMode: '', amount: '', status: 'New Lead', remarks: 'New', hasOrder: false },
  { id: '123543', date: '18/03/2024, 04:09 PM', name: 'Ashok Bhardwaj', phone: 'XXXXXX2456', product: '', category: 'Ayurvedic Men Wellness', payMode: '', amount: '', status: 'Not Connected', remarks: 'New', hasOrder: false },
  { id: '123778', date: '18/03/2024, 04:09 PM', name: 'Nitish Kumar', phone: 'XXXXXX2287', product: '', category: 'Ayurvedic Men Wellness', payMode: '', amount: '', status: 'Call back', remarks: 'New', hasOrder: false },
  { id: '123456', date: '18/03/2024, 04:09 PM', name: 'Dlip Joshi', phone: 'XXXXXX2345', product: '', category: 'Ayurvedic Men Wellness', payMode: '', amount: '', status: 'Call disconnected by customer', remarks: 'New', hasOrder: false },
  { id: '123455', date: '18/03/2024, 04:09 PM', name: 'Aditya Patwa', phone: 'XXXXXX2876', product: '', category: 'Ayurvedic Men Wellness', payMode: '', amount: '', status: 'Future Call back', remarks: 'New', hasOrder: false },
  { id: '123987', date: '18/03/2024, 04:09 PM', name: 'Gyanendra Tiwari', phone: 'XXXXXX2987', product: '', category: 'Ayurvedic Men Wellness', payMode: '', amount: '', status: 'Not Interested', remarks: 'New', hasOrder: false },
  { id: '123343', date: '18/03/2024, 04:09 PM', name: 'Sunita Maurya', phone: 'XXXXXX7899', product: '', category: 'Ayurvedic Men Wellness', payMode: '', amount: '', status: 'Prank call', remarks: 'New', hasOrder: false },
  { id: '123344', date: '18/03/2024, 04:09 PM', name: 'Hemant Mehto', phone: 'XXXXXX2987', product: '3A Piles Care Capsules', category: 'Ayurvedic Men Wellness', payMode: 'Cash', amount: '₹ 1500', status: 'Order Placed', remarks: 'New', hasOrder: true },
  { id: '123556', date: '18/03/2024, 04:09 PM', name: 'Dinesh Kartik', phone: 'XXXXXX1234', product: '', category: 'Ayurvedic Men Wellness', payMode: '', amount: '', status: 'Switch Off', remarks: 'New', hasOrder: false }
];

// Mock Orders Data
export const mockOrders = [
  {
    id: 'OD3455',
    date: '23/03/2024, 05:09 PM',
    customerName: 'Hemant Mehto',
    phone: 'XXXXXX2987',
    product: '3A Piles Care Capsules',
    category: 'Ayurvedic Men Wellness',
    restAmount: '1500',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Order Placed',
    state: 'Uttar Pradesh'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 04:33 PM',
    customerName: 'Sumit Kumar Upa...',
    phone: 'XXXXXX2987',
    product: 'Shilajit 25-Gold 30 Capsules',
    category: 'Ayurvedic Men Wellness',
    restAmount: '5480',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Rejected',
    state: 'Bihar'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 04:41 PM',
    customerName: 'Dilip Topi',
    phone: 'XXXXXX2987',
    product: 'Aaroprotein Kid',
    category: 'Ayurvedic',
    restAmount: '400',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Dispatched',
    state: 'Delhi'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 03:12 PM',
    customerName: 'Deep Singh',
    phone: 'XXXXXX2987',
    product: 'Aaroweight Capsule',
    category: 'Ayurvedic Men Wellness',
    restAmount: '1500',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Ready to ship',
    state: 'Uttar Pradesh'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 02:50 PM',
    customerName: 'Sunita Goswami',
    phone: 'XXXXXX2987',
    product: 'Apple Cider Vinegar',
    category: 'Ayurvedic Men Wellness',
    restAmount: '225',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Verified',
    state: 'Delhi'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 02:02 PM',
    customerName: 'Ruchi Bhardwaj',
    phone: 'XXXXXX2987',
    product: 'Dr. Aarogya Rollon Oil Pure',
    category: 'Ayurvedic Men Wellness',
    restAmount: '700',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Pending',
    state: 'Arunachal Pradesh'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 01:09 PM',
    customerName: 'Rohit Mehra',
    phone: 'XXXXXX2987',
    product: 'Fit Shifa Tablet & Fit Shifa Paras Combo',
    category: 'Ayurvedic Men Wellness',
    restAmount: '1500',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Pick Up Complete',
    state: 'West Bengal'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 12:15 PM',
    customerName: 'Dinesh Lal',
    phone: 'XXXXXX2987',
    product: 'BDH-Cough Syrup',
    category: 'Ayurvedic Men Wellness',
    restAmount: '200',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'In transit',
    state: 'Meghalaya'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 11:12 AM',
    customerName: 'Sumit Kumar Upa...',
    phone: 'XXXXXX2987',
    product: 'Shilajit 25-Gold 30 Capsules',
    category: 'Ayurvedic Men Wellness',
    restAmount: '5480',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Delivered',
    state: 'Uttar Pradesh'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 12:15 PM',
    customerName: 'Dinesh Lal',
    phone: 'XXXXXX2987',
    product: 'BDH-Cough Syrup',
    category: 'Ayurvedic Men Wellness',
    restAmount: '200',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Out for delivery',
    state: 'Meghalaya'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 12:15 PM',
    customerName: 'Dinesh Lal',
    phone: 'XXXXXX2987',
    product: 'BDH-Cough Syrup',
    category: 'Ayurvedic Men Wellness',
    restAmount: '200',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Undelivered',
    state: 'Meghalaya'
  },
  {
    id: 'OD3456',
    date: '23/03/2024, 12:15 PM',
    customerName: 'Dinesh Lal',
    phone: 'XXXXXX2987',
    product: 'BDH-Cough Syrup',
    category: 'Ayurvedic Men Wellness',
    restAmount: '200',
    paymentMode: 'COD',
    orderType: 'Fresh Order',
    status: 'Hold',
    state: 'Meghalaya'
  }
];
// Dashboard Statistics
export const dashboardStats = [
  {
    label: 'Total Orders', value: 126, color: 'bg-blue-500', icon: <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0.95812C0 0.428964 0.428965 0 0.958121 0H12.2575C12.7866 0 13.2156 0.428965 13.2156 0.958121V2.9368H0V0.95812Z" fill="#4AA0FE" />
      <path d="M12.4893 10.7822C12.4893 11.3113 12.0603 11.7402 11.5312 11.7402H1.7002C1.17104 11.7402 0.742193 11.3114 0.742188 10.7822V3.66406H5.14355V5.87109H8.08008V3.66406H12.4893V10.7822Z" fill="#4AA0FE" />
      <rect x="5.86719" y="3.67188" width="1.4684" height="1.4684" fill="#4AA0FE" />
    </svg>

  },
  { label: 'Complete Orders', value: 72, color: 'bg-green-500', icon: '✓' },
  { label: 'Process Orders', value: 16, color: 'bg-yellow-500', icon: '⚡' },
  { label: 'Pending Orders', value: 12, color: 'bg-orange-500', icon: '⏱' },
  { label: 'Hold Orders', value: 3, color: 'bg-gray-500', icon: '⏸' },
  { label: 'Rejected Orders', value: 2, color: 'bg-red-500', icon: '✕' },
  { label: 'OFD Orders', value: 54, color: 'bg-cyan-500', icon: '🚚' },
  { label: 'Delivered Orders', value: 14, color: 'bg-emerald-500', icon: '✓' },
  { label: 'RTO Orders', value: 12, color: 'bg-purple-500', icon: '↩' }
];
